import { enums } from '@bluecrew/bluecrew-lib'
const {filter, propEq, sort, last} = require('ramda')

class StatusChangeController {
  /* @ngInject */
  constructor (roster, $mdDialog, PayrollService, Shifts, $mdToast, startClock, endClock, $mdpTimePicker) {
    console.log(startClock)
    this.PayrollService = PayrollService
    this.Shifts = Shifts
    this.$mdToast = $mdToast
    this.worker = roster
    this.$mdpTimePicker = $mdpTimePicker,
    this.shift = roster
    if (roster.timestamps) {
      this.clockIns = filter(propEq('type', 'SHIFT_START'), roster.timestamps)
      if (this.clockIns) {
        this.clockIn = new date(this.clockIns[0].time)
      }
      this.clockOuts = filter(propEq('type', 'SHIFT_END'), roster.timestamps)
      if (this.clockOuts) {
        this.clockOut = new date(last(this.clockOuts).time)
      }
      this.lunchIns = filter(propEq('type', 'LUNCH_START'), roster.timestamps)
      this.lunchOuts = filter(propEq('type', 'LUNCH_END'), roster.timestamps)
    }
    this.$mdDialog = $mdDialog
    this.showReason = false
    this.isOnShift = false
    this.minStartDate = new Date()
    this.minEndDate = new Date()
    this.enums = enums
    this.otherReasonId = 19
    this.reason = null
    this.note = null
    this.$mdDialog = $mdDialog
    this.PayrolllHoursStatus = enums.PayrollHoursStatus

    this.enums = enums
    // this.actionName = ''
    // switch(newStatus){
    //   case enums.PayrollHoursStatus.APPROVED:
    //     this.actionName = 'APPROVE'
    //     break
    //   case enums.PayrollHoursStatus.REJECTED:
    //     this.actionName = 'REJECT'
    //     break
    //   case enums.PayrollHoursStatus.EXCUSED:
    //     this.actionName = 'EXCUSE'
    //     break
    // }
  }

  calcTotalHours (user) {
    if (user.status === this.PayrollHoursStatus.APPROVED) {
      const minutes = differenceInMinutes(new Date(user.hoursEnd), new Date(user.hoursStart))
      return (minutes / 60 - user.lunchDuration).toFixed(2)
    }

    if (user.lunch != parseInt(user.lunch)) {
      user.error = 'invalid lunch value'
      return ''
    }

    let start = null
    let end = null

    if (user.isEdited.start) {
      start = user.editedTimes.start
    } else if (user.clockedTimestamps.start) {
      start = user.clockedTimestamps.start.time
    } else {
      start = user.shiftStart
    }
    start = user.editedTimes.start

    if (user.isEdited.end) {
      end = user.editedTimes.end
    } else if (user.clockedTimestamps.end) {
      end = user.clockedTimestamps.end.time
    } else {
      end = user.shiftEnd
    }
    end = user.editedTimes.end

    if (start === null || end === null) {
      user.error = 'missing start or end'
      return ''
    } else {
      if (start > end) {
        user.error = 'start can\'t be after end'
        return ''
      }

      const hours = this.Shifts.calcTotalHours(start, end, user.lunch)
      if (hours < 0) {
        user.error = 'hours can\'t be negative'
        return ''
      }

      user.error = null
      return hours
    }
  }

  submit () {
    this.$mdDialog.hide({
      reason: this.reason, note: this.note
    })
  }

  cancel () {
    this.$mdDialog.cancel()
  }
}

export default StatusChangeController
